module.exports = __webpack_public_path__ + "img/Flag_of_Hungary.28cb15c1.svg";